module.exports = __webpack_public_path__ + "static/media/CARS2.6955ca7d.jpg";